import { IAPIMetadataItem } from 'library/ts/interfaces/metadata/api/IAPIMetadataItem';
import { MPXAssetType } from 'library/ts/model/enums/mpx/MPXAssetType';
import { PlayerAdapterVideoFormat } from 'library/ts/player/adapter/enums/PlayerAdapterVideoFormat';
import { ILogger } from 'library/ts/utilities/logger/interfaces/ILogger';
import { LogService } from 'library/ts/utilities/logger/LogService';

/**
 * @copyright © Paramount Streaming
 * @author Snehal Kanungo, Aza Kolbaev
 * @description STV Utilities
 */

export class STVUtilities {

	private static instance: STVUtilities;
	#logger: ILogger;
	#PLATFORM_SAMSUNG_TIZEN = 'samsung-tizen';
	#PLATFORM_LG_WEBOS = 'lg_webOS';
	#PLATFROM_VIZIO = 'vizio';
	#platforms = {
		'lg-webos': {
			getPlatformEnvToId: ( isConviva ) => ( isConviva ? 'PP_LG' : 'lg' ),
			msID: '989161',
			deviceCategory: 'LGTV'
		},
		ps4: {
			getPlatformEnvToId: ( isConviva ) => ( isConviva ? 'PP_PS4' : 'ps4' ),
			msID: 'CUSA05365',
			deviceCategory: ''
		},
		ps5: {
			getPlatformEnvToId: ( isConviva ) => ( isConviva ? 'PP_PS5' : 'ps5' ),
			msID: 'PPSA03933',
			deviceCategory: ''
		},
		vizio: {
			getPlatformEnvToId: ( isConviva ) => ( isConviva ? 'PP_Vizio' : 'viziotv' ),
			msID: 'vizio.cbs',
			deviceCategory: 'TV'
		},
		comcast: {
			getPlatformEnvToId: ( isConviva ) => ( isConviva ? 'PP_Comcast' : 'comcast' ),
			msID: 'paramountPlus',
			deviceCategory: 'XF'
		},
		cox: {
			getPlatformEnvToId: ( isConviva ) => ( isConviva ? 'PP_COX' : 'cox' ),
			msID: 'paramountPlus',
			deviceCategory: 'XF'
		},
		// TODO: Set configs for Samsung-tizen
		// 'samsung-tizen': {
		//     getPlatformEnvToId: isConviva => {
		//         const isIntl = isIntlSelector(store.getState());
		//         if (isConviva && !isIntl) {
		//             //so if this is confivia and not international then...
		//             return 'PP_SamsungTV';
		//         } else if (isConviva && isIntl) {
		//             //but if this is confivia and is international then...
		//             return 'PPINTL_SamsungTV';
		//         } else {
		//             //otherwise we just go ahead and return
		//             return 'samsungtv';
		//         }
		//     },
		//     msID: 'G17292010383',
		//     deviceCategory: 'SAMSUNGTV',
		// },
		xboxone: {
			getPlatformEnvToId: ( isConviva ) => ( isConviva ? 'PP_XboxOne' : 'xboxone' ),
			msID: '9wzdncrfj0wk',
			deviceCategory: 'XB'
		},
		vidaa: {
			getPlatformEnvToId: ( isConviva ) => ( isConviva ? 'PP_VIDAA' : 'vidaa' ),
			msID: 'unknown',
			deviceCategory: ''
		},
		default: {
			getPlatformEnvToId: () => 'unknown',
			msID: 'unknown',
			deviceCategory: ''
		}
	};

	private constructor() {
		if ( STVUtilities.instance ) {
			throw new Error( this.name + ' is a Singleton and can only be accessed through ' + this.name + '.getInstance()' );
		}
		STVUtilities.instance = this;
		this.#logger = LogService.create( { prefixes: [ 'SmartTag:', 'Tag:', this.name ] } );
	}

	get name(): string {
		return 'STVUtilities';
	}

	static getInstance() {
		if ( !STVUtilities.instance ) {
			STVUtilities.instance = new STVUtilities();
		}
		return STVUtilities.instance;
	}

	/**
	 * @description Gets platform Id
	 * @param platform
	 * @param isConviva
	 */
	getPlatformEnvToId = ( platform: string, isConviva = false ) => {
		this.#logger.log( platform );
		return this.#platforms[ platform ]?.getPlatformEnvToId?.( isConviva ) ?? this.#platforms[ 'default' ].getPlatformEnvToId();
	};

	/**
	 * @description Gets content format
	 * @param media
	 */
	getFormat = ( media: IAPIMetadataItem ) => {
		switch ( media.assetType ) {
			case MPXAssetType.DASH_CBCS_CMAF:
			case MPXAssetType.DASH_CENC:
			case MPXAssetType.DASH_CENC_HDR:
			case MPXAssetType.DASH_CENC_HDR10:
			case MPXAssetType.DASH_CENC_LGCY:
			case MPXAssetType.DASH_CENC_PRECON:
			case MPXAssetType.DASH_CMAF:
			case MPXAssetType.DASH_LIVE:
			case MPXAssetType.DASH_TA:
				return PlayerAdapterVideoFormat.DASH;
			default:
				return PlayerAdapterVideoFormat.HLS;
		}
	};

	/**
	 * @description Filter out premium audio codecs
	 * @param platform
	 */
	canFilterOutPremiumAudioCodecs = ( platform ) => {
		return platform === this.#PLATFORM_LG_WEBOS || platform === this.#PLATFROM_VIZIO;
	};

}